import { AppSetting } from './appsetting.constant';

export class ValidationConstant {
  // between 14 - 50 characters, one number,one upper and lower case character and one special character
  public static readonly passwordRegex =
    "^(?=.*[0-9])(?=.*[!@#$%^&'+\\=\\-\\_\\|\\(\\)\\{\\}\\[\\])*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*'\\=\\-+\\_\\|\\(\\)\\{\\}\\[\\]]{13,50}$";
  public static readonly firstNameLastName_regex = "^[a-zA-Z]+([a-zA-Z ,.'-]+)*$";
  public static readonly alphanumeric_numeric_atleast_one_letter =
    /^(?=.*[a-zA-Z])[a-zA-Z0-9]{7,}$/;
  public static readonly phoneFormat_regex = /^[0-9-]*$/;
  public static readonly email_regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static readonly alphanumericWithSpaceAndSomeSpecialChar_regex =
    "^[a-zA-Z0-9]+([a-zA-Z0-9 ,.'-]+)*$";
  public static readonly charactersOnlyWithSpace_regex = "^[a-zA-Z0-9.,'`-]+([a-zA-Z0-9 .,'`-]+)*$";
  public static readonly url_regex =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/;
  public static readonly spaceNotAccepted_regex =
    '^[a-zA-Z0-9~!@#$%^&*()_+{}|:"<>?`\\-=\\[\\]\\\\;\',./]+([a-zA-Z0-9~!@#$%^&*()_+{}|:"<>?`\\-=\\[\\]\\\\;\',./ \r\n|\r|\n]+)*$';
  public static readonly base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  public static readonly defaultPageSize = 10;

  public static readonly login = {
    username: { name: 'User Name', maxLength: 50, minLength: 7 },
    password: { name: 'Password', maxLength: 50, minLength: 8 },
  };

  public static readonly rollApiKey = {
    note: { name: 'Note', minLength: 1 },
    password: { name: AppSetting.pwd, minLength: 12 },
  };

  public static readonly forgotPassword = {
    username: { name: 'User Name', maxLength: 50, minLength: 7 },
  };

  public static readonly transaction = {
    searchInput: { name: 'Search', minLength: 3 },
  };

  public static readonly changePassword = {
    oldPassword: { name: `Old Password`, maxLength: 50, minLength: 14 },
    newPassword: { name: `New Password`, maxLength: 50, minLength: 14 },
    confirmPassword: { name: `Confirm Password`, maxLength: 50, minLength: 14 },
  };

  public static readonly user = {
    searchInput: { name: 'Search', minLength: 3 },
    add: {
      firstName: { name: 'First Name', minLength: 5, maxLength: 50 },
      middleName: { name: 'Middle Name', minLength: 5, maxLength: 50 },
      lastName: { name: 'Last Name', minLength: 5, maxLength: 50 },
      userName: { name: 'Username', minLength: 7, maxLength: 50 },
      department: { name: 'Department', minLength: 5, maxLength: 50 },
      phone: {
        name: 'Phone',
        minLength: 10,
        maxLength: 12,
        mask_minLength: 10,
        mask_maxLength: 10,
      },
      email: { name: 'Email', minLength: 5, maxLength: 256 },
      addressLine1: { name: 'Address Line 1', minLength: 5, maxLength: 50 },
      addressLine2: { name: 'Address Line 2', minLength: 5, maxLength: 50 },
      city: { name: 'City', minLength: 5, maxLength: 50 },
      state: { name: 'State', minLength: 5, maxLength: 50 },
      role: { name: 'Role', minLength: 5, maxLength: 50 },
      country: { name: 'Country', minLength: 5, maxLength: 50 },
      postalCode: {
        name: 'Postal (Zip) Code',
        minLength: 5,
        maxLength: 10,
        mask_minLength: 9,
        mask_maxLength: 9,
      },
    },
  };
  public static readonly refund = {
    refundType: { name: 'Refund Type' },
    amount: { name: 'Partial Amount' },
  };

  public static readonly confirmRefund = {
    reson: { name: 'Reason for Refund' },
    additionalDetails: { name: 'Additional Details', minLength: 1, maxLength: 140 },
  };

  public static readonly webhookSetting = {
    webhookURL: { name: 'Webhook URL', maxLength: 2048 },
    modules: { name: 'Modules' },
    version: { name: 'Version' },
    authenticationType: { name: 'AuthenticationType' },
    hmacKey: { name: 'Hmac Key', minLength: 30, maxLength: 250 },
    key: { name: 'Key' },
    value: { name: 'Value' },
    url: { name: 'URL' },
    username: { name: 'Username' },
    password: { name: AppSetting.pwd },
    response: { name: 'Response' },
    bearerToken: { name: 'BearerToken' },
  };

  public static readonly notificationTemplate = {
    inputEmail: { name: 'Email', minLength: 5, maxLength: 50 },
  };
}
